import axios, { AxiosError } from 'axios';
import { Environment } from '../../../environment';
import { v4 as uuidv4 } from 'uuid';
import { Api } from '../axios-config';
import { comOffline } from '../../../offline/servico';
import { conexao } from '../../../offline/conexao';
import { buscarParceiros, adicionarParceiroLocal } from '../../../offline/cadastros';
import { enfileirar } from '../../../offline/fila';

export interface IListagemParceiros {
   idparceiro: string,
   nome: string,
   cpf: string,
   apelido:string,
   cfop: number;
   diasvencimento: number;
}
export interface IDetalheParceiros {
    nome:string,
    cpf:string,
    fantasia:string,
    rg:string,
    telefone: string,
    celular: string,
    endereco: string,
    numero: string,
    bairro: string,
    idmunicipio:string,
    cep:string,
    email: string,
    obs: string,
    cfop: number,
    contribuinte: number,
    presenca: number,
    consumidorfinal:number,  
    emailnfe: string;
    enviaremail: boolean;
  
}

type TotalCount = {
    data: IListagemParceiros[];
    totalCount: number;
}

interface ErrorResponse {
  errors: {
    default: string;
  };
}


const getAll = async (pagina = 1, filter = '', tipo=''): Promise<TotalCount | Error> => {
  try {
    const urlRelativa = `/parceiros?page=${pagina}&limit=${Environment.LIMITE_DE_CADASTRO}&filter=${filter}&tipo=${tipo}`;
    const { data, headers } = await Api.get(urlRelativa);
    if (data) {
      return {
        data,
        totalCount: Number(headers['x-total-count'] || Environment.LIMITE_DE_CADASTRO),
      };
    }
    return new Error('Erro ao listar os registros.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
const getById = async (id: string): Promise<IDetalheParceiros | Error> => {
  try {
    const { data } = await Api.get(`/parceiros/${id}`);
    if (data) {
      return data;
    }
    return new Error('Erro ao consultar o registro.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
const createOnline = async (guuid: string, dados: IDetalheParceiros): Promise<string | Error> => {
  try {
    const { data } = await Api.post<IDetalheParceiros>('/parceiros',  {idparceiro: guuid, ...dados});
    if (Object.keys(data).length === 0) {
      return guuid;
    }
    return new Error('Erro ao criar o registro.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
const updateById = async (id: string, dados: IDetalheParceiros): Promise<void | Error> => {
  try {
    await Api.put(`/parceiros/${id}`, dados);
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
const deleteById = async (id: string): Promise<void | Error> => {
  try {
    await Api.delete(`/parceiros/${id}`);
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
const getAllListOnline = async (filter = '', id = '', pagina = 1, limit = Environment.LIMITE_DE_LINHAS): Promise<TotalCount | Error> => {
  try {
    const urlRelativa: string = id === '' ?  `/parceiroslist?page=${pagina}&limit=${limit}&filter=${filter}&tipo=nome` : `/parceiroslist/${id}`;
    const { data, headers } = await Api.get(urlRelativa);
    if (data) {
      return {
        data,
        totalCount: Number(headers['x-total-count'] || Environment.LIMITE_DE_LINHAS),
      };
    }
    return new Error('Erro ao listar os registros.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
// Sem internet, o parceiro novo entra na cópia local (já aparece na busca e
// pode ir pra venda na hora) e numa fila, enviado na próxima sincronização
// com o mesmo idparceiro — as vendas offline que usam ele chegam ao
// servidor depois dele (a fila respeita a ordem).
const createLocal = async (guuid: string, dados: IDetalheParceiros): Promise<string | Error> => {
  const payload = { idparceiro: guuid, ...dados };
  const idconta = String(Api.defaults.headers.idconta || '');
  await enfileirar('parceiro', idconta, payload, { nome: dados.nome }, guuid);
  await adicionarParceiroLocal({ ...payload, status: true, pendente: true });
  return guuid;
};

const create = async (dados: IDetalheParceiros): Promise<string | Error> => {
  const guuid = uuidv4();
  if (conexao.estaOffline()) return createLocal(guuid, dados);
  const resultado = await createOnline(guuid, dados);
  if (resultado instanceof Error && conexao.estaOffline()) return createLocal(guuid, dados);
  return resultado;
};

const getAllList = (filter = '', id = '', pagina = 1, limit = Environment.LIMITE_DE_LINHAS): Promise<TotalCount | Error> =>
  comOffline(
    () => getAllListOnline(filter, id, pagina, limit),
    () => buscarParceiros(filter, id, pagina, limit),
  );

export const ParceirosService = {
  getAll,
  create,
  getById,
  updateById,
  deleteById,
  getAllList,
};